import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(30)})`,
    '& .MuiTab-root': {
      fontSize: theme.spacing(1.75),
      color: theme.palette.text.secondary,
    },

    '& .MuiTabs-root': {
      padding: theme.spacing(0),
    },

    '& .MuiTab-root.Mui-selected': {
      color: theme.palette.text.primary,
    },
  },
  tabsPanel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  search: {
    maxWidth: theme.spacing(30),
    marginLeft: 'auto',
    marginRight: theme.spacing(0.5),
  },
  listContainer: {
    height: '100%',
  },
}));
